'use client'

import { useEffect } from 'react'

/** Registers the offline shell service worker. Never caches /api. */
export function ServiceWorkerRegister() {
  useEffect(() => {
    if (typeof window === 'undefined' || !('serviceWorker' in navigator)) return
    if (process.env.NODE_ENV !== 'production') return
    navigator.serviceWorker.register('/sw.js').catch(() => undefined)
  }, [])
  return null
}
